import React from "react";
import { useTranslation } from "react-i18next";

import {
    Card,
    CardHeader,
    CardHeaderTitle,
    FieldRow,
    FieldLabel,
    Toggle,
    ResetIconButton,
} from "./styled";
import { ResetIcon } from "./ResetIcon";

type PageTitleCardProps = {
    titleEnabled: boolean;
    mainColor: string;
    onToggle: () => void;
    onReset: () => void;
};

export function PageTitleCard({
    titleEnabled,
    mainColor,
    onToggle,
    onReset,
}: PageTitleCardProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Card>
            <CardHeader>
                <CardHeaderTitle>{t("Page title")}</CardHeaderTitle>
                <ResetIconButton
                    data-testid="servio-home-reset-title-btn"
                    mainColor={mainColor}
                    onClick={onReset}
                    title={t("Reset to default")}
                >
                    <ResetIcon />
                    {t("Reset")}
                </ResetIconButton>
            </CardHeader>
            <FieldRow>
                <FieldLabel>{t("Show page title")}</FieldLabel>
                <Toggle
                    data-testid="servio-home-title-toggle"
                    isActive={titleEnabled}
                    mainColor={mainColor}
                    onClick={onToggle}
                />
            </FieldRow>
        </Card>
    );
}
